import { iotData } from "./aws.js";
import axios from "axios";
import { TOPICS } from "./topics.js";

const {
  LOCATION: { TRIP_DATA, LIVE_LOCATION },
} = TOPICS;

const host = "https://api.otanextdev.visteoncloud.com";
// local
// const host = "http://localhost:3500";

export const _sendTripData = async (payload) => {
  console.log("Publishing Trip data to server:", payload);
  const iotDataInstance = await iotData();
  console.log("IotData instance created:", iotDataInstance);
  const topic = TRIP_DATA.replace("{serialNo}", payload.serialNo); // Replace with actual serial number
  return iotDataInstance
    .publish({
      topic: topic,
      payload: JSON.stringify(payload),
      qos: 0,
      retain: false,
    })
    .promise();
};

export const sendTripData = async (payload, creds) => {
  console.log("Publishing Trip data to server:", payload);
  const iotDataInstance = await iotData(creds);
  const topic = TRIP_DATA.replace("{serialNo}", payload.serialNo);
  return iotDataInstance
    .publish({
      topic: topic,
      payload: JSON.stringify(payload),
      qos: 0,
      retain: false,
    })
    .promise();
};

export const getTripsList = async (serialNo) => {
  const startDate = new Date("2023-01-29T18:30:00.000Z").toISOString();
  // set the hours to 23:59:59 for endDate
  const now = new Date();
  const endDate = new Date(now.setHours(23, 59, 59, 999)).toISOString();
  // const url = `https://api.otanextdev.visteoncloud.com/vehicles/trips?serialno=${serialNo}&startdate=2023-01-29T18:30:00.000Z&enddate=2025-06-30T18:29:59.059Z`; // Replace with actual vehicleKey
  const url = `${host}/vehicles/trips?serialno=${serialNo}&type=tripstart&startdate=${startDate}&enddate=${endDate}`; // Replace with actual vehicleKey
  return await axios.get(url, { headers: { "x-customer-id": "HD" } });
};

export const getTrip = async (tripId) => {
  const url = `${host}/vehicles/trip/details/${tripId}`; // Replace with actual vehicleKey
  return await axios.get(url, { headers: { "x-customer-id": "HD" } });
};

let PREVIOUS_LAST_LIVE_TRACKING_SESSION_UPDATE = new Date().getTime();
const CheckLiveTrackingUpdateInterval = (interval) => {
  const now = new Date().getTime();
  const timePassed = now - PREVIOUS_LAST_LIVE_TRACKING_SESSION_UPDATE;
  if (timePassed > interval) {
    PREVIOUS_LAST_LIVE_TRACKING_SESSION_UPDATE = now;
    return true;
  } else {
    PREVIOUS_LAST_LIVE_TRACKING_SESSION_UPDATE = now;
    return false;
  }
};
export const sendLiveLocationDataToMqttTopic = async (payload, creds) => {
  // const samplePayloadStructure = {
  //   type: "live_tracking",
  //   subType: "session_update",
  //   id: "3a3cf6c1-a32e-45a6-b069-e0c00703d493",
  //   serialNo: "THINEXT_23092024117",
  //   vehicleKey:
  //     "6387BD119FCCC2809DE8CDA1F4125228F6DD1A2E18712D43458C93FDBBBDF8E1",
  //   time: "",
  //   location: {
  //     longitude: 12.967090247180218,
  //     latitude: 80.19582698476104,
  //   },
  // };
  // if (CheckLiveTrackingUpdateInterval(3000)) {

  // }
  const { serialNo } = payload || {};
  if (!serialNo) {
    throw new Error("Missing serialNo in payload");
  }
  const iotDataInstance = await iotData(creds);
  const topic = LIVE_LOCATION.replace("{serialNo}", serialNo);
  return iotDataInstance
    .publish({
      topic: topic,
      payload: JSON.stringify(payload),
      qos: 0,
      retain: false,
    })
    .promise();
};

export const getGeofencesList = async (vehicleKey) => {
  const url = `${host}/companionapp/geofence/vehicle/${vehicleKey}`; // Replace with actual vehicleKey
  return await axios.get(url, { headers: { "x-customer-id": "HD" } });
};

export const saveGeofenceToServer = async (fenceData) => {
  const url = `${host}/companionapp/geofence`;
  return await axios.post(url, fenceData, {
    headers: { "x-customer-id": "HD" },
  });
};

export const enableOrDisableGeofenceById = async ({ state, geofenceId }) => {
  const url = `${host}/companionapp/geofence/${geofenceId}`;
  return await axios.put(
    url,
    {
      status: state,
    },
    {
      headers: { "x-customer-id": "HD" },
    }
  );
};

export const startLiveTrackingSession = async (payload) => {
  console.log("Starting Live Tracking Session");
  const url = `${host}/companionapp/startlivetrackingsession`;
  return await axios.post(
    url,
    {
      vehicleKey: payload.vehicleKey,
      serialNo: payload.serialNo,
    },
    {
      headers: { "x-customer-id": "HD" },
    }
  );
};

export const stopLiveTrackingSession = async (payload) => {
  console.log("Stopping Live Tracking Session");
  const url = `${host}/companionapp/endlivetrackingsession`;
  return await axios.post(
    url,
    {
      vehicleKey: payload.vehicleKey,
      serialNo: payload.serialNo,
      sessionId: payload.sessionId,
    },
    {
      headers: { "x-customer-id": "HD" },
    }
  );
};
